import {React} from "react";

import "./App.css";
import WhatsappLogo from '../images/whatsapp-icon.png';
import InstagramLogo from '../images/insta-icon.png';
import TiktokLogo from '../images/tiktok-icon.png';
import GymHouseLogo from '../images/gymHouse-logo.png';
import FadyPhoto from '../images/Team/fadyAtallah.png';
import EmilioPhoto from '../images/Team/CoachEmilio.jpg';
import JoePhoto from '../images/Team/CoachJoe.jpg';
import DoryPhoto from '../images/Team/CoachDory.jpg';
import GoogleMapsLogo from '../images/GoogleMaps-icon.png';
import { useNavigate } from "react-router-dom";
import {   Row,  Form } from "react-bootstrap";
import { coaches } from "../properties";


export default function CoachesForm() {
  const queryParameters = new URLSearchParams(window.location.search)
  const coachNameString = queryParameters.get("coachName")
  const navigate = useNavigate();
  var coachName ={}
  if(coachNameString==='fady')
   coachName = coaches.fady
if(coachNameString==='dory')
 coachName = coaches.dory
 if(coachNameString==='joe')
 coachName = coaches.joe
 if(coachNameString==='emilio')
 coachName = coaches.emilio
 if(coachNameString==='ranime')
 coachName = coaches.ranime


  
    
  const whatsapplink = "https://wa.me/"+coachName.PhoneNumber
  const instagramlink = coachName.Instagram
  const tiktoklink = coachName.Tiktok
    return (
            <div className="default-page">
            <img onClick={()=>{navigate('/')}} alt="Welcome to GymHouse" className="gymHouse-Logo" src={GymHouseLogo}></img>
              <h1><b>Welcome To Our Family</b></h1>
              <div className="spacer"></div>
              <div className="spacer"/>
              <h2><b>Meet coach {coachName.FirstName} !</b></h2>
              <div className="spacer"/>
              <div className="spacer"/>
              <img className="coachPic" src={`data:image/jpeg;base64,${coachName.photo}`} />
              {/* {coachName.FirstName === 'Fady' ? <img alt="Welcome to GymHouse" className="coachPic" src={FadyPhoto}></img> : <></>}
              {coachName.FirstName === 'Emilio' ? <img alt="Welcome to GymHouse" className="coachPic" src={EmilioPhoto}></img> : <></>}
              {coachName.FirstName === 'Joe' ? <img alt="Welcome to GymHouse" className="coachPic" src={JoePhoto}></img> : <></>}
              {coachName.FirstName === 'Dory' ? <img alt="Welcome to GymHouse" className="coachPic" src={DoryPhoto}></img> : <></>} */}
              <div className="spacer"/>
              <div className="spacer"/>
              <hr/>
              <Form  id="coachForm" >
            
              <Row sm={4}>
                <Form.Group controlId="FirstName">
                  <Form.Label className="FormLabel">FirstName<font COLOR="#ff0000"></font></Form.Label>
                  <Form.Control                                     
                    type="text"
                    required disabled
                    defaultValue={coachName.FirstName}
                    name="FirstName"
                    id="FirstName"
                  ></Form.Control>
                </Form.Group>
                <Form.Group controlId="LastName">
                  <Form.Label className="FormLabel">
                    LastName<font COLOR="#ff0000"></font>
                  </Form.Label>
                  <Form.Control
                    type="text"  disabled                    
                    name="LastName"
                    defaultValue={coachName.LastName}
                                     required
                  ></Form.Control>
                </Form.Group>
                
                <Form.Group controlId="Certification Source">
                  <Form.Label className="FormLabel">Certification Source<font COLOR="#ff0000"></font></Form.Label>
                  <Form.Control
                    type="text" disabled
                    required
                    defaultValue={coachName.CertificationSource}
                    name="Certification Source"
                   
                  ></Form.Control>
                </Form.Group>
                <Form.Group controlId="Years of experience">
                  <Form.Label className="FormLabel">Years of experience<font COLOR="#ff0000"></font></Form.Label>
                  <Form.Control
                    type="text" disabled
                    required
                    defaultValue={new Date().getFullYear() - coachName.YearsOfExperience}
                    name="Years of experience"
                   
                  ></Form.Control>
                </Form.Group>
                
              </Row>

             
              <Row >
                <Form.Group controlId="How do i start workout">
                  <Form.Label className="FormLabel">How do i start workout?</Form.Label>
                  <Form.Control
                    type="text" disabled
                    defaultValue={coachName.HowDoIStartWorkout}
                  
                    name="How do i start workout"
                  ></Form.Control>
                </Form.Group>
                </Row>
                <Row >
                <Form.Group controlId="Why do i like to train">
                  <Form.Label className="FormLabel">Why do i like to train?</Form.Label>
                  <Form.Control
                    type="text" disabled
                    defaultValue={coachName.WhyDoILikeToTrain}
                   
                    name="Why do i like to train"
                  ></Form.Control>
                </Form.Group>
                </Row>
                <Row >
                <Form.Group controlId="What is my goal">
                  <Form.Label className="FormLabel">What is my goal?</Form.Label>
                  <Form.Control
                    type="text" disabled
                    defaultValue={coachName.WhatIsMyGoal}
                    
                    name="What is my goal"
                  ></Form.Control>
                </Form.Group>
                </Row>
              
            
            <Row>
              <Form.Group controlId="Main reason to join the family">
                <Form.Label className="FormLabel">Main reason to join the family</Form.Label>
                <Form.Control
                  type="text" disabled
                  defaultValue={coachName.MainReasonToJoinTheFamily}
                  
                  name="Main reason to join the family"
                ></Form.Control>
              </Form.Group>
              {/* <Form.Group controlId="Comments">
                <Form.Label className="FormLabel">Comments</Form.Label>
                <Form.Control
                  type="text"
                                 name="Comments"
                ></Form.Control>
              </Form.Group> */}
            </Row>
            
            <br />
            
            

 
 

              
              {/* <div className='spacer'></div>
                         <Button variant="danger" onClick={this.heandleResetCase}>مسح البيانات</Button> */}
           
          </Form>
                <div className="spacer"/>
                
                <div className="spacer"/>
                <hr/>
                <h2><b>You can reach coach {coachName.FirstName} {coachName.LastName} here:</b></h2>
                <div className="spacer"/>
                <div className="spacer"/>
                <div className="icons-container">
                <div></div>
                <li><a id="whatsappLink" target="blank" href={whatsapplink} ><img alt="Reach us on Whatsapp" className="icons" src={WhatsappLogo}></img></a></li>
                <li><a target="blank" href={instagramlink}><img alt="Reach us on Instagram" className="icons" src={InstagramLogo}></img></a> </li>
                <li><a target="blank" href={tiktoklink ? instagramlink : "https://www.tiktok.com/@gymhouse_lb?_t=8j1PECEQvuE&_r=1"}><img alt="Reach us on Tiktok" className="icons" src={TiktokLogo}></img></a> </li>
                <li><a target="blank" href="https://maps.app.goo.gl/JEc6kySrX7HA9N1S8 " ><img alt="Find us on GoogleMaps" className="icons" src={GoogleMapsLogo}></img></a></li>
                <div></div>
                </div>
                <hr/>
                
             
              
              </div>
    );
  }

